$(document).ready(function(){

    /*//DISPLAY CONFIRMATION//
    //TO DELETE//
    $('#received-gift-card-step-1').hide();
    $('#beauty-quizz').show();
    //STOP DELETING//
    */

    (function(){
        //var url = 'http://localhost:8080';
        var url = 'https://cartes-cadeaux-nuoo.herokuapp.com';
        var profilSaved = {};
        var questions_length;
        var customer_id;
        var cardSubmitted = false;

        $('#agree').change(function() {
          if(this.checked) {
            $('#rgpd__checkbox--agree').hide()
          }
        });

        if (window.location.href.indexOf('/pages/mon-profil-beaute') > -1) {
          $('#validation-quizz').hide()
          customer_id = $('#customerId').val();
          $.ajax({
            type: "GET",
            url: url + '/profil-beaute',
            contentType: 'application/json',
            data: {customer_id: customer_id },
            success: function(data) {
              profilSaved = data.note;
              if (profilSaved.length > 0) {
                questions_length = generateQuizz(profilSaved);
                $('#updateQuizzContainer').show();
              } else {
                questions_length = generateQuizz();
                $('#validateQuizzContainer').show();
              }

            },
            error: function(error) {
              console.log(error);
              console.log('error')
            },
            timeout: 30000
          });
        } else {
          questions_length = generateQuizz();
        }

        var address_id,gift_code;

        // ACTIVER MA CARTE
        $("#gift-code-form").submit(function(e) {
            e.preventDefault();
            var form = $(this);
            $('#errorGiftCodeAfterSent').hide();
            if ($('#code').val().replace(/ |-/g,'').length < 16) {
              $('#errorGiftCode').html('Attention, vous avez entré ' + $('#code').val().replace(/ |-/g,'').length + ' caractères. Il manque ' + (16 - $('#code').val().replace(/ |-/g,'').length) + ' cractères.');
              $('#errorGiftCode').show();
            } else {
              $('#errorGiftCode').hide();
              $.ajax({
                type: "POST",
                url: url + '/gift-card-validate',
                contentType: 'application/json',
                data: JSON.stringify({code: $('#code').val().replace(/ |-/g,'')}),
                success: function(data) {
                    if (data.status == "Success") {

                        gift_code = $('#code').val().replace(/ |-/g,'');
                        $('#infos_perso_first_name').val(data.giftFirstName);
                        $('#infos_perso_last_name').val(data.giftLastName);

                        $('#gift-infos-perso').show();
                        $('#received-gift-card-step-1').hide();
                    } else {
                      $('#errorGiftCodeAfterSent').show();
                    }
                },
                error: function () {
                  console.log('erreur')
                },
                timeout: 30000
              });
            }

        });

        // VALIDER MES INFOS PERSOS
        $('#gift-infos-perso').submit(function(e) {
            e.preventDefault();
            var form = $(this);
            $('#new_name_1').text($('#infos_perso_first_name').val() + ' ' + $('#infos_perso_last_name').val());
            $('#buttonPersoData').hide();
            $('#loaderPersoData').css('display', 'flex');
            $.ajax({
                type: "POST",
                url: url + '/gift-card-infos-perso',
                contentType: 'application/json',
                data: JSON.stringify({first_name: $('#infos_perso_first_name').val(), last_name: $('#infos_perso_last_name').val(), email: $('#infos_perso_email').val() }),
                success: function(data) {
                    customer_id = data.customer_id;
                    if (data.errorNames == true) {
                      $('#new_name_2').text(data.first_name + ' ' + data.last_name);
                      $('#modal-gift-card-button').click();
                      $('#loaderPersoData').hide();
                      $('#buttonPersoData').show();
                    } else {
                      if (data.default_address) {
                        $('input[name=\'address[first_name]\']').val(data.default_address.first_name);
                        $('input[name=\'address[last_name]\']').val(data.default_address.last_name);
                        $('input[name=\'address[company]\']').val(data.default_address.company);
                        $('input[name=\'address[phone]\']').val(data.default_address.phone);
                        $('input[name=\'address[address1]\']').val(data.default_address.address1);
                        $('input[name=\'address[address2]\']').val(data.default_address.address2);
                        $('input[name=\'address[zip]\']').val(data.default_address.zip);
                        $('input[name=\'address[city]\']').val(data.default_address.city);
                        $('input[name=\'address[country]\']').val(data.default_address.country_name);
                      } else {
                        $('input[name=\'address[first_name]\']').val($('#infos_perso_first_name').val());
                        $('input[name=\'address[last_name]\']').val($('#infos_perso_last_name').val());
                      }
                      $('#gift-infos-perso').hide();
                      $('#addressBox').show();
                    }

                },
                timeout: 30000
            });
        });

        // MAUVAIS PRENOM ET/OU NOM
        $('.New-Name-chosen').on('click', function(){
            var values = $(this).text().split(' ');
            var first_name = values[0];
            var last_name = values[1];

            $.ajax({
              type: "POST",
              url: url + '/gift-card-infos-perso',
              contentType: 'application/json',
              data: JSON.stringify({customer_id: customer_id, first_name: first_name, last_name: last_name }),
              success: function(data) {
                if (data.errorNames == false && data.default_address) {
                  $('input[name=\'address[first_name]\']').val(data.default_address.first_name);
                  $('input[name=\'address[last_name]\']').val(data.default_address.last_name);
                  $('input[name=\'address[company]\']').val(data.default_address.company);
                  $('input[name=\'address[phone]\']').val(data.default_address.phone);
                  $('input[name=\'address[address1]\']').val(data.default_address.address1);
                  $('input[name=\'address[address2]\']').val(data.default_address.address2);
                  $('input[name=\'address[zip]\']').val(data.default_address.zip);
                  $('input[name=\'address[city]\']').val(data.default_address.city);
                  $('input[name=\'address[country]\']').val(data.default_address.country_name);
                  $('button.Modal__Close').click();
                  $('#gift-infos-perso').hide();
                  $('#addressBox').show();
                } else {
                  $('input[name=\'address[first_name]\']').val(first_name);
                  $('input[name=\'address[last_name]\']').val(last_name);
                  $('button.Modal__Close').click();
                  $('#gift-infos-perso').hide();
                  $('#addressBox').show();
                }
              },
              timeout: 30000
            });
        });



        var alreadyFilledProfile = false;
        var grouped_quizz_response;
        var profilBeauteProcess = function(resultQuizzText, validationButton) {
          $('#quizz-questions').hide();
          $('#suivant-question').hide();

          $('#quizzAlreadyExists').html(resultQuizzText);
          $('#buttonActivateAbo').text(validationButton);
          $('.cgv-text.carte-recue').show()
          $('#quizzAlreadyExists').show();
          $('#validation-quizz').show();
          $('#redo-quizz').show();

          $('#redo-quizz').on('click', function() {
            alreadyFilledProfile = false;
            $('#quizz-questions').show();
            $('#suivant-question').show();
            $('#quizzAlreadyExists').hide();
            $('#redo-quizz').hide();
            $('#validation-quizz').hide();
            $('.cgv-text.carte-recue').hide()
            $('#buttonActivateAbo').text('Valider mon profil beauté et activer ma carte cadeau');
          });
        };

        // AJOUTER UNE ADRESSEvar alreadyFilledProfile = false;
        $('#addressBox').submit(function(e){
            e.preventDefault();
            $('#buttonAddressData').hide();
            $('#loaderAddressData').css('display', 'flex');
            $.ajax({
                type: "GET",
                url: url + '/profil-beaute',
                contentType: 'application/json',
                data: {customer_id: customer_id },
                success: function(data) {
                    if (Object.keys(data.note).length == 16) {
                      grouped_quizz_response = data.note;
                      profilBeauteProcess('<p>Votre profil beauté est déjà rempli ! Vous pouvez continuer ou répondre à nouveau aux 16 questions.</p>', 'Activer mon abonnement');
                      alreadyFilledProfile = true;
                    } else if (Object.keys(data.note).length > 0) {
                      grouped_quizz_response = data.note;
                      profilBeauteProcess('<p>Nous avons déjà un profil beauté (attention, ce dernier est incomplet) associé à votre compte</p>', 'Activer mon abonnement');
                      alreadyFilledProfile = true;
                    }
                    $('#addressBox').hide();
                    $('#beauty-quizz').show();
                },
                timeout: 30000
            });

        });

        var not_responded = []

        function ChangeQuestion(currentQuestion, question) {
            $(currentQuestion).removeClass('active').addClass('previous-question').hide();
            $(question).fadeIn(300).addClass('active');
        }

        function CheckBlankResponses(grouped_quizz_response) {
          for (var i = 0; i <= (grouped_quizz_response.length - 1); i++) {
            var obj = grouped_quizz_response[i]
            var value = obj[Object.keys(obj)[0]];
            if (value) {
            } else {
              not_responded.push({question: i})
            }
          }
        }



        $('#validation-quizz').on('click', function(e){
          e.preventDefault();
          not_responded = [];
            if (window.location.href.indexOf('/pages/mon-profil-beaute') > -1) {
              if (jQuery('#agree').is(':checked')) {
                $('#validateQuizzContainer').hide();
                $('#updateQuizzContainer').hide();
                $('.loaderContainer').css('display','flex');
              } else {
                $('#errorContainer').hide();
              }
            }
            if (alreadyFilledProfile == false) {
              var quizz_response = $('#quizz').serializeArray();
              grouped_quizz_response = [{'type_de_peau': ''}, {'couleur_peau': ''}, {'préoccupations_visage': ''}, {'compléments_alimentaires': ''}, {'maquillage': ''}, {'nature_de_cheveux': ''}, {'type_de_cheveux': ''}, {'pb_de_cheveux': ''}, {'produits_dédiés': ''}];
              var quizz_order = {type_de_peau: 0, couleur_peau: 1, préoccupations_visage: 2, compléments_alimentaires: 3, maquillage: 4, nature_de_cheveux: 5, type_de_cheveux: 6, pb_de_cheveux: 7, produits_dédiés: 8}

              for(var i = 0; i < quizz_response.length; i++){
                  var rank = quizz_order[quizz_response[i].name.replace('[]', '')];
                  var name = quizz_response[i].name.replace('[]', '');
                  var value = quizz_response[i].value;
                  grouped_quizz_response[rank][name] = value + '/' + grouped_quizz_response[rank][name];
              }
              CheckBlankResponses(grouped_quizz_response);
            }

            if (not_responded.length > 0) {
              var questions = "" ;
              for (var i = 0; i <= (not_responded.length - 1); i++) {
                if (i == 0) {
                  questions = questions + (not_responded[i].question + 1);
                } else {
                  questions = questions + " et " + (not_responded[i].question + 1);
                }
              }
              if (profilSaved.length > 0) {
                $('#updateQuizzContainer').show();
              } else {
                $('#validateQuizzContainer').show();
              }
              $('.loaderContainer').hide();
              $('#questions-blank').text(questions);
              $('#errorContainer').show();
            } else {
              $('#questions-blank').text("");
              $('#errorContainer').hide();
              var customer_email = $('#infos_perso_email').val();

              if (customer_email == undefined) {
                customer_email = $('#customerEmail').val();
              }

              if (cardSubmitted == false) {
                if (window.location.href.indexOf('/pages/mon-profil-beaute') > -1) {
                  if (jQuery('#agree').is(':checked')) {
                    customer_id = $('#customerId').val();
                    $.ajax({
                        type: "POST",
                        url: url + '/profil-beaute',
                        contentType: 'application/json',
                        data: JSON.stringify({email: customer_email, customer_id: customer_id, profil_beaute: grouped_quizz_response }),
                        success: function(data) {
                          $('.loaderContainer').hide();
                          $('#updatedQuizzContainer').show();

                        },
                        error: function(error) {
                          console.log(error);
                          console.log('error')
                        }
                    });
                  } else {
                    $('#errorContainer').hide();
                    jQuery('#rgpd__checkbox--agree').show();
                  }
                } else {
                  cardSubmitted = true;
                  if (jQuery('#agree').is(':checked')) {
                    $('#rgpd__checkbox--agree').hide();
                    $('#buttonActivateAbo').hide();
                    $('#loaderActivateAbo').css('display', 'flex');
                    $.ajax({
                         type: "POST",
                         url: url + '/profil-beaute',
                         contentType: 'application/json',
                         data: JSON.stringify({email: customer_email, customer_id: customer_id, profil_beaute: grouped_quizz_response }),
                         success: function(data) {
                             $.ajax({
                                 type: "POST",
                                 url: url + '/create-subscription',
                                 contentType: 'application/json',
                                 data: JSON.stringify({customer_id: customer_id,
                                     profil_beaute: grouped_quizz_response,
                                     email: $('#infos_perso_email').val(),
                                     first_name: $('#infos_perso_first_name').val(),
                                     last_name: $('#infos_perso_last_name').val(),
                                     first_name_address: $('input[name=\'address[first_name]\']').val(),
                                     last_name_address: $('input[name=\'address[last_name]\']').val(),
                                     company: $('input[name=\'address[company]\']').val(),
                                     phone: $('input[name=\'address[phone]\']').val(),
                                     address1: $('input[name=\'address[address1]\']').val(),
                                     address2: $('input[name=\'address[address2]\']').val(),
                                     zip: $('input[name=\'address[zip]\']').val(),
                                     city: $('input[name=\'address[city]\']').val(),
                                     country: $('select[name=\'address[country]\']').val(),
                                     gift_code: gift_code
                                     // modeLiv: modeLiv,
                                     // idRelais: idRelais
                                 }),
                                 success: function(data) {
                                     if (data.status == 'Success') {
                                       console.log('THIS IS A SUCCESS')
                                         $('#beauty-quizz').hide()
                                         $('#select_shipping').hide();
                                         $('#validation-beauty-profile').hide();
                                         $('#final-success').show();
                                     } else if (data.status == 'erreur') {
                                       $('#loaderActivateAbo').hide();
                                       $('#buttonActivateAbo').css('display', 'flex');
                                       $('#errorValidateBox').show();
                                       setTimeout(function(){
                                         window.location.replace("/pages/carte-cadeau-recue");
                                       }, 12000);
                                     }

                                 },
                                 timeout: 30000
                             });
                         },
                         timeout: 30000
                    });
                  } else {
                    cardSubmitted = false;
                    $('#rgpd__checkbox--agree').show();
                  }

                }


              //JULIEN :
              //VOICI L'ARRAY À UTILISER DANS LE BACK !
              }
            }






        });

        $('#suivant-question').on('click', function(e){
            e.preventDefault();
            var questionNumber = parseInt($('.question.active').attr('question-number'));

            var currentQuestion = '#question-' + questionNumber;
            var nextQuestion = '#question-' + (questionNumber + 1);



            if ($('.question.active .input-selection:checked').length == 0) {
              $('#errorContainer').css("display", "flex");
              if (questions_length-1 === questionNumber) {
                $('#errorContainer').css("justify-content", "center");
              } else {
                $('#errorContainer').css("justify-content", "flex-end");
              }
            } else {
              $('#errorContainer').hide();
              if ( questionNumber === 1 ) {
                $('#precedent-question').show();
              }

              ChangeQuestion(currentQuestion, nextQuestion);

              if (questions_length-1 === questionNumber) {
                $('.cgv-text.carte-recue').show();
                $('#validation-quizz').show();
                $('#suivant-question').hide();
              } else {
                $('.cgv-text.carte-recue').hide();
              }
            }
        });

        // VALIDER MA CARTE CADEAU
        // $('#validation-beauty-profile').on('click', function() {


        // $('#buttonActivateAbo').hide();
        // $('#loaderActivateAbo').css('display', 'flex');

        // $.ajax({
        // type: "POST",
        // url: url + '/profil-beaute',
        // contentType: 'application/json',
        // data: JSON.stringify({customer_id: customer_id, profil_beaute: grouped_quizz_response }),
        // success: function(data) {
        // var modeLiv = $('.input-delivery:checked').val();
        // var idRelais = '';
        // if (modeLiv.indexOf('Mondial Relay') > -1) {
        // idRelais = $('#relay-chosen').val();
        // }
        // $.ajax({
        // type: "POST",
        // url: url + '/create-subscription',
        // contentType: 'application/json',
        // data: JSON.stringify({customer_id: customer_id,
        // profil_beaute: grouped_quizz_response,
        // email: $('#infos_perso_email').val(),
        // first_name: $('#infos_perso_first_name').val(),
        // last_name: $('#infos_perso_last_name').val(),
        // first_name_address: $('input[name=\'address[first_name]\']').val(),
        // last_name_address: $('input[name=\'address[last_name]\']').val(),
        // company: $('input[name=\'address[company]\']').val(),
        // phone: $('input[name=\'address[phone]\']').val(),
        // address1: $('input[name=\'address[address1]\']').val(),
        // address2: $('input[name=\'address[address2]\']').val(),
        // zip: $('input[name=\'address[zip]\']').val(),
        // city: $('input[name=\'address[city]\']').val(),
        // country: $('select[name=\'address[country]\']').val(),
        // gift_code: gift_code
        // // modeLiv: modeLiv,
        // // idRelais: idRelais
        // }),
        // success: function(data) {
        // if (data.status == 'Success') {
        // $('#select_shipping').hide();
        // $('#validation-beauty-profile').hide();
        // $('#final-success').show();
        // } else if (data.status == 'erreur') {
        // $('#loaderActivateAbo').hide();
        // $('#buttonActivateAbo').css('display', 'flex');
        // $('#errorValidateBox').show();
        // setTimeout(function(){
        // window.location.replace("/pages/carte-cadeau-recue");
        // }, 12000);
        // }

        // },
        // timeout: 30000
        // });
        // },
        // timeout: 30000
        // });
        // });

        $('#precedent-question').on('click', function(e){
            e.preventDefault();
            $('#validation-quizz').hide();
            $('#suivant-question').show();
            var questionNumber = parseInt($('.question.active').attr('question-number'));
            var currentQuestion = '#question-' + questionNumber;

            var previousQuestion = '#question-' + parseInt(questionNumber-1);
            if ( questionNumber === 2 ) {
              $('#precedent-question').hide();
            }

            $(currentQuestion).removeClass('active').hide();
            $(previousQuestion).fadeIn(300).addClass('active');

        });
    }());

});


var generateQuizz = function(profilSaved){
    var quizz = [
        {
            choice_number : 1,
            categorie : '',
            question : 'Quel est votre type de peau (Q1/9) ?',
            name : 'type_de_peau',
            responses : [
                {
                    label : 'Peau grasse',
                    value : 'grasse'
                },
                {
                    label : 'Peau mixte',
                    value : 'mixte'
                },
                {
                    label : 'Peau normale',
                    value : 'normale'
                },
                {
                    label : 'Peau sèche',
                    value : 'sèche'
                }
            ]
        },
        {
            choice_number : 1,
            categorie : '',
            question : 'Votre peau est (Q2/9)',
            name : 'couleur_peau',
            responses : [
                {
                    label : '<span class="pastille" style="background-color: #ffebd0 "></span>Très claire',
                    value : 'très claire'
                },
                {
                    label : '<span class="pastille" style="background-color: #f3ccbc "></span>Claire',
                    value : 'claire'
                },
                {
                    label : '<span class="pastille" style="background-color: #f3bfa0 "></span>Medium',
                    value : 'medium'
                },
                {
                    label : '<span class="pastille" style="background-color: #d5a076 "></span>Mate',
                    value : 'mate'
                },
                {
                    label : '<span class="pastille" style="background-color: #a07859 "></span>Foncée',
                    value : 'foncée'
                },
                {
                    label : '<span class="pastille" style="background-color: #564030 "></span>Très foncée',
                    value : 'très foncée'
                }
            ]
        },
        {
            choice_number : undefined,
            categorie : '',
            question : 'Si la sélection du mois contient des produits de soins pour le visage dédiés aux besoins listés ci-dessous, lesquels vous concernent ? (Q3/9)',
            name : 'préoccupations_visage',
            responses : [
                {
                    label : 'Le manque d’hydratation (manque d’eau, tiraillements, ridules de déshydratation)',
                    value : 'manque hydratation'
                },
                {
                    label : 'La sécheresse (manque de sébum, tiraillements, inconfort, peau qui pèle, rugosités)',
                    value : 'sécheresse'
                },
                {
                    label : 'La sensibilité et les rougeurs (échauffement, réaction aux changements de température, aux émotions) ',
                    value : 'sensibilité et rougeurs'
                },
                {
                    label : 'Le manque d’éclat (teint terne)',
                    value : 'manque d\'éclat test s'
                },
                {
                    label : 'Les rides et la fermeté',
                    value : 'rides et fermeté'
                },
                {
                    label : 'Les pores dilatés et l\'excès de sebum',
                    value : 'pores dilatées et excès de sébum'
                },
                {
                    label : 'Les imperfections (points noirs, boutons)',
                    value : 'imperfections test'
                },
                {
                    label : 'Les taches pigmentaires et/ou cicatrices',
                    value : 'taches pigmentaires'
                },
                {
                    label : 'Les cernes et/ou poches',
                    value : 'cernes ou poches'
                },
                {
                    label : 'Aucune problématique particulière à signaler !',
                    value : 'aucune'
                }
            ]
        },
        {
            choice_number : 1,
            categorie : '',
            question : 'Si la sélection du mois contient des compléments alimentaires, aimeriez-vous les découvrir ?  (Q4/9)',
            name : 'compléments_alimentaires',
            responses : [
                {
                    label : 'Oui',
                    value : 'oui'
                },
                {
                    label : 'Non, je ne prends jamais de compléments alimentaires',
                    value : 'non'
                },
            ]
        },
        {
            choice_number : undefined,
            categorie : '',
            question : 'Si la sélection du mois contient du maquillage, vous aimeriez découvrir des produits de maquillage pour (Q5/9)',
            name : 'maquillage',
            responses : [
                {
                    label : 'Les yeux',
                    value : 'yeux'
                },
                {
                    label : 'Les sourcils',
                    value : 'sourcils'
                },
                {
                    label : 'Les lèvres',
                    value : 'lèvres'
                },
                {
                    label : 'Le teint',
                    value : 'teint'
                },
                {
                    label : 'Les ongles',
                    value : 'ongles'
                },
                {
                    label : 'Aucun, je ne me maquille pas',
                    value : 'aucun'
                }
            ]
        },
        {
            choice_number : 1,
            categorie : '',
            question : 'La nature de mes cheveux (Q6/9)',
            name : 'nature_de_cheveux',
            responses : [
                {
                    label : 'Raides',
                    value : 'raides'
                },
                {
                    label : 'Souples',
                    value : 'souples'
                },
                {
                    label : 'Bouclés / ondulés',
                    value : 'bouclés ou ondulés'
                },
                {
                    label : 'Frisés / crépus',
                    value : 'frisés ou crépus'
                },
            ]
        },
        {
            choice_number : 1,
            categorie : '',
            question : 'Votre cuir chevelu est :  (Q7/9)',
            name : 'type_de_cheveux',
            responses : [
                {
                    label : 'Gras',
                    value : 'gras'
                },
                {
                    label : 'Sec',
                    value : 'sec'
                },
                {
                    label : 'Normal',
                    value : 'normal'
                }
            ]
        },
        {
            choice_number : undefined,
            categorie : '',
            question : 'Si la sélection du mois contient des soins capillaires dédiés aux besoins listés ci-dessous, lesquels vous concernent ? (Q8/9)',
            name : 'pb_de_cheveux',
            responses : [
                {
                    label : 'Mes cheveux ont tendance à regraisser vite',
                    value : 'regraisssent vite'
                },
                {
                    label : 'Mes cheveux sont secs et abîmés',
                    value : 'sec et abîmés'
                },
                {
                    label : 'Mes cheveux manquent de volume',
                    value : 'manquent de volume'
                },
                {
                    label : 'Mes cheveux manquent de brillance et d’éclat',
                    value : 'manquent de brillance'
                },
                {
                    label : 'Mes cheveux sont colorés',
                    value : 'colorés'
                }
            ]
        },
        {
            choice_number : undefined,
            categorie : '',
            question : 'Si la sélection du mois contient des produits dédiés aux besoins spécifiques listés ci-dessous, aimeriez-vous les recevoir ? (Q9/9)',
            name : 'produits_dédiés',
            responses : [
                {
                    label : 'Soins pour les bébés',
                    value : 'aux bébés'
                },
                {
                    label : 'Soins pour les enfants et ados',
                    value : 'aux enfants et ados'
                },
                {
                    label : 'Soins pour les femmes enceintes',
                    value : 'aux femmes enceintes'
                },
                {
                    label : 'Soins dédiés aux hommes',
                    value : 'aux hommes'
                },
                {
                    label : 'Non',
                    value : 'aucun'
                }
            ]
        }
    ];

    if (profilSaved) {
      profilSaved = profilSaved.reduce(function(acc, x) {
        for (var key in x) acc[key] = x[key];
        return acc;
      }, {});
    }
    for (var i = 0; i < quizz.length; i++) {
        var fieldset = $('<fieldset question-number="' + parseInt(i+1) + '" id="question-'+ parseInt(i+1) +'" class="question"></fieldset>');

        if (i === 0)
            fieldset.addClass('active');
        var categorie = '';
        if (quizz[i].categorie) {
          quizz[i].categorie = quizz[i].categorie + ' : '
        }
        var legend = $('<legend>' + quizz[i].categorie + quizz[i].question +'</legend>');
        fieldset.append(legend)

        for(var j = 0; j < quizz[i].responses.length; j++){
            var response = quizz[i].responses[j];
            var div = $('<div></div>');
            var input;

            if (profilSaved) {
              if (quizz[i].name in profilSaved) {
                if (profilSaved[quizz[i].name].indexOf('très claire') > -1 && response.value == 'claire') {
                  input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '">')
                } else if (profilSaved[quizz[i].name].indexOf('très foncée') > -1 && response.value == 'foncée') {
                  input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '">')
                } else if (profilSaved[quizz[i].name].indexOf(response.value) > -1) {
                  input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '" checked >')
                } else {
                  input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '">')
                }
              } else {
                input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '">')
              }

            } else {
              input = $('<input class="input-selection" type="checkbox" limit="' + quizz[i].choice_number + '" id="Q' + parseInt(i+1) + '-'+ j +'" name="'+ quizz[i].name + '" value="' + response.value + '">')
            }

            var label = $('<label class="label-quizz" for="Q' + parseInt(i+1) + '-' + j+'">' + response.label +'</label>')

            div.append(input);
            div.append(label);

            fieldset.append(div)
        }

        $('#loaderBeforeQuizz').hide();
        $('#quizz-questions').append(fieldset);

        $('[name="' + quizz[i].name + '"]').on('change', function(evt) {
          $('#errorContainer').hide();
          if ($(this).attr('limit') !== undefined){
            var limit = parseInt($(this).attr('limit'));
            var checked_checkbox = $('[name="' + this.name +'"]:checked');

            if( checked_checkbox.length > limit) {
              if(!checked_checkbox.first().is($(this)))
                  var last = checked_checkbox.first();
              else
                  var last = $(checked_checkbox[1])

              last.attr('checked', false)
            }
          }
        });
    }

    $('#validation-quizz').hide();
    $('#pageLayoutCompteProfilBeaute #validation-quizz').show();
    setTimeout(function(){
      window.scrollTo(0, 0);
    }, 200);

    return quizz.length;
}
